import { Component, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import * as uuid from 'uuid';
import { BcitiSelectListDropdownComponent } from '../select-list-dropdown/bciti-select-list-dropdown.component';

export interface BcitiTextSelectOption {
    label: string;
    value: any;
    color?: string;
}

@Component({
    selector: 'app-bciti-text-select',
    templateUrl: './bciti-text-select.component.html',
    styleUrls: ['./bciti-text-select.component.scss'],
})
export class BcitiTextSelectComponent implements OnInit, ControlValueAccessor {
    public onChange: (v?: any) => {};
    public onTouched: () => {};
    public id: string;
    public _value: BcitiTextSelectOption;

    @Input() options: BcitiTextSelectOption[] = [];
    @Input() disabled: boolean;
    @Input() label: string;
    @Input() placeholder: string;
    @Input() validation: boolean = true;
    @Input() disableMessages: boolean = false;
    @Input() loading: boolean = false;

    @Output('change') changeOutput = new EventEmitter<BcitiTextSelectOption>();
    @Output() blur = new EventEmitter<Event>();

    @ViewChild(BcitiSelectListDropdownComponent)
    public dropdown: BcitiSelectListDropdownComponent;

    @Input()
    get value(): BcitiTextSelectOption {
        return this._value;
    }

    set value(v: BcitiTextSelectOption) {
        this._value = v;
        const value = {
            label: v.label,
            value: v.value,
        };
        this.changeOutput.emit(value);
        if (this.onChange) {
            this.onChange(value);
            this.onTouched();
        }
    }

    get invalid() {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid() {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine() {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty() {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched() {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    valueChange(e: any): void {
        this.value = e;
    }

    onBlur(event: Event): void {
        this.blur.emit(event);
        if (this.onTouched) {
            this.onTouched();
        }
    }

    writeValue(v: any): void {
        this._value = v;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    select(option: BcitiTextSelectOption): void {
        this.valueChange(option);
        this.hideDropdown();
    }

    showDropdown() {
        if (!this.loading) {
            this.dropdown.show();
        }
    }

    hideDropdown() {
        this.dropdown.hide();
        if (this.onTouched) {
            this.onTouched();
        }
    }
}
